export const CATEGORY_BINGO = 'BINGO'
export const CATEGORY_CASINO = 'CASINO'
export const CATEGORY_SLOTS = 'SLOTS'
export const CATEGORY_SUBTYPE_COLLECTOR = 'COLLECTOR'
export const CATEGORY_SUBTYPE_LIVE = 'LIVE'
